import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import RightsCheck from "../General/RightsCheck";
import { scrollToTop } from "../Shared/ScrollOnTop";
import config from "../../Config";
import axios from "axios";

function SupportTopMenu() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [counts, setCounts] = useState({
    OpenTickets: 0,
    AwaitingReply: 0,
    CloseCount: 0,
  });

  useEffect(() => {
    axios({
      method: "post",
      url: config.base_url + "Support/GetSupportTicket",
      headers: { "Content-Type": "application/json" },
      data: { AccessKey, UserID, pageNo: 1, pageSize: 1 },
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          setCounts({
            OpenTickets: response.data.OpenTickets || 0,
            AwaitingReply: response.data.AwaitingReply || 0,
            CloseCount: response.data.CloseCount || 0,
          });
        }
      })
      .catch(() => {});
  }, []);

  const withCount = (label, count) =>
    count > 0 ? `${label} (${count})` : label;

  return (
    <>
      <RightsCheck />
      <nav className="navbar navbar-expand-lg navbar-module MenuSticky">
        <div className="container-fluid">
          <div className="collapse navbar-collapse">
            <ul className="navbar-nav m-auto">
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/support/raise-ticket"
                >
                  Raise Ticket
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/support/open"
                >
                  {withCount("Open", counts.OpenTickets)}
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/support/inbox"
                >
                  {withCount("Inbox", counts.AwaitingReply)}
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/support/tickets-close"
                >
                  {withCount("Closed", counts.CloseCount)}
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  onClick={scrollToTop}
                  className="nav-link"
                  to="/support/ticket-types"
                >
                  Ticket Types
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default SupportTopMenu;
